module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('convergence-graph', {
    attrs: {
      "jobId": _vm.jobId
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-298fc178", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-298fc178"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/convergence-watcher/convergence-watcher.vue.html
// module id = 1087
// module chunks = 0